import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const SiteStatusContext = createContext({ maintenance: null, banner: null, resellers: null, loaded: false, refresh: () => {} });

export function SiteStatusProvider({ children }) {
  const [status, setStatus] = useState({ maintenance: null, banner: null, resellers: null, loaded: false });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site/status");
      setStatus({ maintenance: data.maintenance, banner: data.banner, resellers: data.resellers, loaded: true });
    } catch (e) {
      setStatus((s) => ({ ...s, loaded: true }));
    }
  }, []);

  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, 30000);
    const onVisible = () => document.visibilityState === "visible" && refresh();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [refresh]);

  const value = useMemo(() => ({ ...status, refresh }), [status, refresh]);
  return <SiteStatusContext.Provider value={value}>{children}</SiteStatusContext.Provider>;
}

export const useSiteStatus = () => useContext(SiteStatusContext);
